export default "__VITE_ASSET__o9B_DnaW__"